module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/219-isle-of-man-67b78d7bb1bf4c39d93cea9937cfdd76.svg";